import { render } from "./ConsistencyCheckSection.vue?vue&type=template&id=1832229a"
import script from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"
export * from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__